import { render, staticRenderFns } from "./bmdReport.vue?vue&type=template&id=64823613&scoped=true"
import script from "./bmdReport.vue?vue&type=script&lang=js"
export * from "./bmdReport.vue?vue&type=script&lang=js"
import style0 from "./bmdReport.vue?vue&type=style&index=0&id=64823613&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64823613",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64823613')) {
      api.createRecord('64823613', component.options)
    } else {
      api.reload('64823613', component.options)
    }
    module.hot.accept("./bmdReport.vue?vue&type=template&id=64823613&scoped=true", function () {
      api.rerender('64823613', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/printReport/bmdReport/bmdReport.vue"
export default component.exports